var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "meeting-agenda__list-item" },
    [
      _c(
        "router-link",
        { staticClass: "meeting-agenda__link", attrs: { to: _vm.link } },
        [
          _c("div", { staticClass: "grid" }, [
            _c(
              "div",
              {
                staticClass:
                  "grid__col--1--half meeting-agenda__icon h-left-align"
              },
              [
                _c("i", {
                  staticClass: "fa fa-calendar-day meeting-agenda__link-icon"
                }),
                _vm._v(" " + _vm._s(_vm.agenda.meeting_date))
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "grid__col--3 meeting-agenda__name" }, [
              _vm._v(_vm._s(_vm.agenda.title))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "grid__col--3--half meeting-agenda__description",
              domProps: { innerHTML: _vm._s(_vm.agenda.description) }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid__col--2 meeting-agenda__attendees" },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.contactAttendeesString) + "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid__col--2 meeting-agenda__attendees" },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.fuelAttendeesString) + "\n      "
                )
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }